export default {
  // Admin
  1: [
    { id: 'ROLE_USER_MANAGEMENT_VIEW', icon: 'analytics', url: 'ReportAdminIndex', i18n: 'menu.report_school' },
    { id: 'ROLE_USER_MANAGEMENT_VIEW', icon: 'bank', url: 'SchoolIndex', i18n: 'menu.manage_school' },
    { id: 'ROLE_USER_MANAGEMENT_VIEW', icon: 'customer-plus', url: 'MasterUser', i18n: 'menu.manage_user' },
    { id: 'ROLE_USER_MANAGEMENT_VIEW', icon: 'customers', url: 'Role', i18n: 'menu.manage_role' }
    // { id: 'ROLE_USER_MANAGEMENT_VIEW', icon: 'ic-school-active', url: 'SchoolV1Index', i18n: 'menu.manage_school_v1' },
    // { id: 'ROLE_USER_MANAGEMENT_VIEW', icon: 'ic_setting', url: 'MenuListLite', i18n: 'content.setting_lite' },
    // { id: 'ROLE_USER_MANAGEMENT_VIEW', icon: 'customer-plus', url: 'MasterUserLite', i18n: 'menu.user_lite' }
  ],

  // School
  2: [
    { id: 'ROLE_USER_MANAGEMENT_VIEW', icon: 'customer-plus', url: 'MasterUserSchool', i18n: 'menu.manage_user' },
    { id: 'ROLE_TEACHER_MANAGEMENT_VIEW', icon: 'jobs', url: 'TeacherIndex', i18n: 'menu.manage_teacher' },
    { id: 'ROLE_CLASS_LEVEL_MANAGEMENT_VIEW', icon: 'activities', url: 'StudentIndex', i18n: 'menu.manage_student' },
    { id: 'ROLE_CLASS_LEVEL_MANAGEMENT_VIEW', icon: 'activities', url: 'ParentIndex', i18n: 'menu.parent' },
    { id: 'ROLE_CLASS_LEVEL_MANAGEMENT_VIEW', icon: 'analytics', url: 'ClassLevelIndex', i18n: 'menu.manage_grade' },
    { id: 'ROLE_GROUP_MANAGEMENT_VIEW', icon: 'affiliate', url: 'EnrollStudentIndex', i18n: 'menu.manage_group' },
    { id: 'ROLE_COURSE_MANAGEMENT_VIEW', icon: 'vocabulary', url: 'CourseIndex', i18n: 'menu.course_management' },
    { id: 'ROLE_CLASS_MANAGEMENT_VIEW', icon: 'desktop', url: 'SchoolClassIndex', i18n: 'menu.manage_class' },
    { id: 'ROLE_REPORT_VIEW', icon: 'legal', url: 'ReportSchoolIndex', i18n: 'menu.report' },
    { id: 'ROLE_CLASS_LEVEL_MANAGEMENT_VIEW', icon: 'ic_setting_class', url: 'MenuListClass', i18n: 'content.setting_class' },
    { id: 'ROLE_CLASS_LEVEL_MANAGEMENT_VIEW', icon: 'anal_icon', url: 'MenuListAnalytical', i18n: 'content.anal' }
  ],

  // School Advisor
  6: [
    { id: 'ROLE_STUDENT_MANAGEMENT_VIEW', icon: 'activities', url: 'StudentIndex', i18n: 'menu.manage_student' },
    { id: 'ROLE_CLASS_LEVEL_MANAGEMENT_VIEW', icon: 'analytics', url: 'ClassLevelIndex', i18n: 'menu.manage_grade' },
    { id: 'ROLE_GROUP_MANAGEMENT_VIEW', icon: 'affiliate', url: 'EnrollStudentIndex', i18n: 'menu.manage_group' },
    { id: 'ROLE_COURSE_MANAGEMENT_VIEW', icon: 'vocabulary', url: 'CourseIndex', i18n: 'menu.course_management' },
    { id: 'ROLE_CLASS_MANAGEMENT_VIEW', icon: 'desktop', url: 'AdvisorClassIndex', i18n: 'menu.manage_class' },
    { id: 'ROLE_REPORT_VIEW', icon: 'legal', url: 'ReportSchoolIndex', i18n: 'menu.report' }
  ],

  // Parent
  3: [
    { id: 'ROLE_CLASS_MANAGEMENT_VIEW', icon: 'desktop', url: 'ParentClassIndex', i18n: 'menu.class' },
    { id: 'ROLE_SCHEDULE_VIEW', icon: 'calendar-tick', url: 'Schedule', i18n: 'menu.schedule' }
  ],

  // Teacher
  4: [
    { id: 'ROLE_CLASS_MANAGEMENT_VIEW', icon: 'desktop', url: 'TeacherClassIndex', i18n: 'menu.class' },
    { id: 'ROLE_COURSE_MANAGEMENT_LITE_VIEW', icon: 'vocabulary', url: 'CourseIndex', i18n: 'menu.course_management' },
    { id: 'ROLE_CLASS_MANAGEMENT_LITE_VIEW', icon: 'desktop', url: 'TeacherClassIndex', i18n: 'menu.class' },
    { id: 'ROLE_SCHEDULE_VIEW', icon: 'calendar-tick', url: 'TeacherSchedule', i18n: 'menu.schedule' },
    { id: 'ROLE_SCHEDULE_LITE_VIEW', icon: 'calendar-tick', url: 'TeacherSchedule', i18n: 'menu.schedule' },
    { id: 'ROLE_QUIZ_VIEW', icon: 'iq', url: 'QuizTeacherIndex', i18n: 'menu.manage_quiz' },
    { id: 'ROLE_SYLLABUS_VIEW', icon: 'ic-syllabus', url: 'SyllabusIndex', i18n: 'content.syllabus_manajement' },
    { id: 'ROLE_SYLLABUS_LITE_VIEW', icon: 'ic-syllabus', url: 'SyllabusIndex', i18n: 'content.syllabus_manajement' },
    { id: 'ROLE_QUIZ_LITE_VIEW', icon: 'iq', url: 'QuizTeacherIndex', i18n: 'menu.manage_quiz' },
    { id: 'ROLE_BANK_SOAL_LITE_VIEW', icon: 'bank-soal', url: 'BankSoalIndex', i18n: 'content.bank_soal_ic' },
    { id: 'ROLE_BANK_SOAL_VIEW', icon: 'bank-soal', url: 'BankSoalIndex', i18n: 'content.bank_soal_ic' },
    { id: 'ROLE_REPORT_LITE_VIEW', icon: 'report-storage', url: 'ReportStorageIndex', i18n: 'content.report_storage' },
    { id: 'ROLE_ERAPOR_VIEW', icon: 'ic_erapor', url: 'eRaporIndex', i18n: 'content.e_rapor' }
  ],

  // Student
  5: [
    { id: 'ROLE_CLASS_MANAGEMENT_VIEW', icon: 'desktop', url: 'StudentClassIndex', i18n: 'menu.class' },
    { id: 'ROLE_CLASS_MANAGEMENT_LITE_VIEW', icon: 'desktop', url: 'StudentClassIndex', i18n: 'menu.class' },
    { id: 'ROLE_SCHEDULE_VIEW', icon: 'calendar-tick', url: 'Schedule', i18n: 'menu.schedule' },
    { id: 'ROLE_SCHEDULE_LITE_VIEW', icon: 'calendar-tick', url: 'Schedule', i18n: 'menu.schedule' }
  ]
};
